import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
    Container,
    Typography,
    Box,
    IconButton,
    Stack,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ViewFormTemplateContainer from './containers/ViewFormTemplateContainer'

const ViewFormTemplatePage: React.FC = () => {
    const { templateId } = useParams<{ templateId: string }>()
    const navigate = useNavigate()

    if (!templateId) {
        return (
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Typography color="error">Template ID is required</Typography>
            </Container>
        )
    }

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Stack spacing={3}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton
                        onClick={() => navigate('/admin/forms')}
                        size="small"
                        sx={{ mr: 1 }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h4" component="h1">
                        Form Template Details
                    </Typography>
                </Box>
                <ViewFormTemplateContainer templateId={templateId} />
            </Stack>
        </Container>
    )
}

export default ViewFormTemplatePage 